/**
 * @deprecated 더 이상 권장되지 않으며, 점진적으로 제거 예정입니다.
 *
 * CustomRoutes
 *
 * React Router의 <Routes>를 감싼 래퍼 컴포넌트로,
 * 하위 <Route /> 컴포넌트의 path 값을 가공하여 중복된 prefix를 제거하거나 경로를 정리하는 용도로 사용됨.
 *
 * 초기 구조에서는 모든 경로를 절대경로(ROUTE 상수)로 관리하면서,
 * 중첩된 라우팅 구조와 충돌을 피하기 위해 도입되었음.
 *
 * 현재는 getRelativeRoute 유틸 도입과 중첩 구조 개선을 통해 제거 가능하지만,
 * 과거 코드와의 호환성 및 적용 범위가 넓어 당분간 유지 예정임.
 * → 'src/app/(main)/routes/channel/SettingRoute.tsx' 참고
 *
 * 궁극적으로는 React Router의 공식 중첩 구조(useRoutes, 상대 path)를 따르고,
 * 이 컴포넌트는 점진적으로 제거가 필요함.
 */

import React, {useMemo} from 'react';
import {Route, Routes} from 'react-router-dom';
import NotFound from '@/app/(main)/routes/not-found.jsx';

const removePrefixFromPath = (path) => {
  if (typeof path === 'string') {
    return path
      .replace(/^\/my/, '')
      .replace(/^\/directory/, '')
      .replace(/^\/search/, '')
      .replace(/^\/live/, '')
      .replace(/^\/station/, '')
      .replace(/^\/help/, '');
  }
  return path;
};

const CustomRoutes = ({children}) => {
  const modifyRoutes = (children) => {
    return React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) {
        return child;
      }

      // 자식 요소를 재귀적으로 처리
      const newChildren = child.props.children
        ? modifyRoutes(child.props.children)
        : child.props.children;

      // 경로를 문자열로 확인하여 수정
      const newPath =
        typeof child.props.path === 'string'
          ? removePrefixFromPath(child.props.path)
          : child.props.path;

      return React.cloneElement(child, {
        path: newPath,
        children: newChildren,
      });
    });
  };

  const modifiedChildren = useMemo(() => modifyRoutes(children), [children]);

  return (
    <Routes>
      {modifiedChildren}
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
};

export default CustomRoutes;
